export default "__VITE_ASSET__DE9VOphe__"